import React, {Component} from "react"
import PropTypes from "prop-types"
import authentication from "@irati/auth"

import {Body, H2, H3, Label} from "@irati/ui/src/Typography"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import categoriesService from "@irati/deals/services/dealCategory"
import {walletTracking} from "@irati-tracking/wallet"
import {SPEND} from "@irati/deals/constants/categoryTypes"
import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {Wallet, DealCategory} from "@irati/types"
import {hangPromise} from "@irati/utils/promise"
import mainTheme from "@irati/ui/src/global/theme"
import Flex from "@irati/ui/src/Flex"
import {ActiveCard} from "./styled"

interface Props {
  wallet: Wallet
  active: boolean
}

interface State {
  loadCategories: Promise<any>
  spendCategory?: DealCategory | null
}

class CashWallet extends Component<Props, State> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }
  state: State = {
    spendCategory: null,
    loadCategories: hangPromise()
  }

  componentDidMount() {
    const loadCategories = categoriesService.listForCurrentPackage().then((dealCategories) => {
      this.setState({
        spendCategory: dealCategories.find((category) => category.type === SPEND)
      })
    })

    this.setState({loadCategories})
  }

  render() {
    const {wallet, active} = this.props
    const {availableBalance, currency} = wallet
    const {spendCategory, loadCategories} = this.state
    const {apps} = this.context
    const idNamespace = id("balances", this.props)

    return (
      <ActiveCard id={idNamespace} marginTop={5} active={active}>
        <H3 color={mainTheme.colors.utility.ink} marginBottom={2}>
          <FormattedMessage id="wallet.walletBalanceCard.cash.title" />
        </H3>
        <Flex justifyContent="space-between">
          <Flex direction="column" id={id("available-balance", idNamespace)}>
            <Label color={mainTheme.colors.utility.contrast}>
              <FormattedMessage id="wallet.walletBalanceCard.available.header" />
            </Label>
            <H2 color={mainTheme.colors.tertiary.g_400}>
              {currency && <FormattedCurrency isCents={false} value={availableBalance} currency={currency} />}
            </H2>
          </Flex>
        </Flex>

        <div>
          <Body color={mainTheme.colors.utility.contrast} marginTop={2} marginBottom={2}>
            <FormattedMessage id="wallet.availableBalance.info.text" />
          </Body>
          <ButtonRouterLink
            id={id("browse-perks-button", idNamespace)}
            primary
            full
            stopPropagation
            onClick={walletTracking.clickBrowsePerks}
            load={loadCategories}
            to={spendCategory ? `/categories/${spendCategory.url}` : "/categories"}
            app={apps.PERKS}>
            <FormattedMessage id="wallet.availableBalance.info.button" />
          </ButtonRouterLink>
          {!authentication.apps("admin.billingUnit") && (
            <ButtonRouterLink
              id={id("send-credit-button", idNamespace)}
              full
              stopPropagation
              load={loadCategories}
              to="/send-credit"
              marginTop={2}>
              <FormattedMessage id="wallet.availableBalance.info.sendCreditbutton" />
            </ButtonRouterLink>
          )}
        </div>
      </ActiveCard>
    )
  }
}

export default CashWallet
